module.exports = __webpack_public_path__ + "img/plainpackage.9fc38841.png";